/**
 * @generated SignedSource<<f6d4cb9ffa87313ec03ab2fb8620a81f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTitleWithByLine_content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_content">;
  readonly " $fragmentType": "ContentTitleWithByLine_content";
};
export type ContentTitleWithByLine_content$key = {
  readonly " $data"?: ContentTitleWithByLine_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useNewContentTopper"
    }
  ],
  "kind": "Fragment",
  "name": "ContentTitleWithByLine_content",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "useNewContentTopper",
          "variableName": "useNewContentTopper"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ContentTitle_content"
    }
  ],
  "type": "Content"
};

(node as any).hash = "989b7f71498c47b5f4399620db2d95b5";

export default node;
